import React, { useMemo, useRef } from "react";
import { PeekBox, PeekStack } from "@piiqtechnologies/ui-components";
import { LocationTabContent, AmmenitiesTabContent, CommuteTabContent, PriceLayoutTabContent, } from "../custom-subtopics-tabs-content";
const TAB_IDS = ["location", "amenities", "commute", "price-layout"];
const TAB_CONTENT_MAP = {
    location: LocationTabContent,
    amenities: AmmenitiesTabContent,
    commute: CommuteTabContent,
    "price-layout": PriceLayoutTabContent,
};
export const CustomSubtopicsBody = ({ activeTabId, addedCountsPerTab, maxAddedSubtopics, baseSubtopicsData, onAddedCountChange, onSubtopicsDataChange, onToggleCommit, saveTrigger, onEditingCountChange, initialData, readOnly, allowLayoutToggle, hasBeenRun, }) => {
    const onAddedCountChangeRef = useRef(onAddedCountChange);
    onAddedCountChangeRef.current = onAddedCountChange;
    const onEditingCountChangeRef = useRef(onEditingCountChange);
    onEditingCountChangeRef.current = onEditingCountChange;
    // Stable per-tab handler references that never change identity, avoiding
    // unnecessary re-renders of tab content components on tab switch.
    const tabHandlers = useMemo(() => Object.fromEntries(TAB_IDS.map((tabId) => [
        tabId,
        {
            onAddedCountChange: (count) => { var _a; return (_a = onAddedCountChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onAddedCountChangeRef, tabId, count); },
            onEditingCountChange: (count) => { var _a; return (_a = onEditingCountChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onEditingCountChangeRef, tabId, count); },
        },
    ])), []);
    return (React.createElement(PeekStack, { m: 1.5, flex: 1, overflow: "hidden" }, TAB_IDS.map((tabId) => {
        const Content = TAB_CONTENT_MAP[tabId];
        if (!Content)
            return null;
        return (React.createElement(PeekBox, { key: tabId, sx: {
                display: activeTabId === tabId ? "flex" : "none",
                flex: 1,
                overflow: "hidden",
            } },
            React.createElement(Content, { maxAddedSubtopics: maxAddedSubtopics, otherTabsAddedCount: Object.entries(addedCountsPerTab)
                    .filter(([id]) => id !== tabId)
                    .reduce((sum, [, c]) => sum + c, 0), baseSubtopicsData: baseSubtopicsData, onAddedCountChange: tabHandlers[tabId].onAddedCountChange, onSubtopicsDataChange: onSubtopicsDataChange, onToggleCommit: onToggleCommit, saveTrigger: saveTrigger, onEditingCountChange: tabHandlers[tabId].onEditingCountChange, initialData: initialData, readOnly: readOnly, allowLayoutToggle: allowLayoutToggle, hasBeenRun: hasBeenRun })));
    })));
};
